import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideUpdateDateBlockData from '../../../Models/Content/GenericGuideUpdateDateBlockData';
import GenericGuideUpdateDate from './GenericGuideUpdateDateBlock';

export default class GenericGuideUpdateDateBlock extends EpiComponent<GenericGuideUpdateDateBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-update-date-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideUpdateDate iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

